<form
  class="update-record-dialog"
  [formGroup]="serviceForm"
  (ngSubmit)="createReminder()"
>
  <section class="record-summary" aria-label="Service reminder context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-bell"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">New Service Reminder</span>
      <h2>{{ serviceForm.get('vehicle_reference')?.value || 'Select a vehicle' }}</h2>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Reminder details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="vehicleRef">Vehicle Reference <span class="required-star">*</span></label>
        <p-dropdown
          inputId="vehicleRef"
          placeholder="Select a Vehicle"
          formControlName="vehicle_reference"
          optionLabel="vehicle_reference"
          [options]="vehicleList"
          optionValue="vehicle_reference"
          [filter]="true"
          filterBy="vehicle_reference"
          appendTo="body"
          styleClass="w-full"
        ></p-dropdown>
        <small
          class="p-error"
          *ngIf="serviceForm.get('vehicle_reference')?.invalid && (serviceForm.get('vehicle_reference')?.dirty || serviceForm.get('vehicle_reference')?.touched)"
        >
          Vehicle Reference is required
        </small>
      </div>

      <div class="form-field">
        <label for="serviceDueDate">Service Due Date <span class="required-star">*</span></label>
        <p-calendar
          inputId="serviceDueDate"
          formControlName="service_due_date"
          dateFormat="yy-mm-dd"
          [inline]="false"
          [(ngModel)]="date"
          appendTo="body"
          styleClass="w-full"
        ></p-calendar>
        <small
          class="p-error"
          *ngIf="serviceForm.get('service_due_date')?.invalid && (serviceForm.get('service_due_date')?.dirty || serviceForm.get('service_due_date')?.touched)"
        >
          Service Due Date is required
        </small>
      </div>

      <div class="form-field">
        <label for="serviceDelta">KM Remaining Before Service</label>
        <input
          id="serviceDelta"
          pInputText
          type="number"
          formControlName="service_delta"
          placeholder="e.g. 5000"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="kmReading">Odometer Reading (optional)</label>
        <input
          id="kmReading"
          pInputText
          type="number"
          formControlName="km_reading"
          placeholder="e.g. 145000"
          class="w-full"
        />
      </div>
    </div>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Save Reminder"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
